import { NavigateFunction } from "react-router-dom";
import * as XLSX from "xlsx";


export const getFileName = (name: string) => {
  const date = new Date().toISOString().split("T")[0];
  return `${name}-${date}`;
};

export const exportToExcel = <T extends Record<string, any>>(
  fileName: string,
  data: T[]
) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};


export const toBool = (strBool: "true" | "false"): boolean => {
  const lookup = {
    "true": true,
    "false": false,
  };

  return lookup[strBool];
};


export function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

/**
 * Checks if a given value is an empty plain object.
 * @param obj - The value to check.
 * @return True if value is an empty plain object, otherwise false.
 */
export const isEmptyObject = (obj: unknown): boolean => {
  if (!obj) {
    return true;
  }
  return obj.constructor === Object && Object.keys(obj).length === 0;
}

export function getQueryParam(param: string): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get(param);
}


export const getCurrentHostInfo = () => {
  const protocol = window.location.protocol; // http: or https:
  const hostname = window.location.hostname; // e.g., demo-hotel.wiventory.com
  const hostParts = hostname.split(".");     // ["demo-hotel", "wiventory", "com"]
  const subdomain = hostParts[0];

  return {
    protocol,
    hostname,
    hostParts,
    subdomain
  };
};


export const getUrl = (useSubdomain?: boolean) => {
const { protocol, hostname, subdomain } = getCurrentHostInfo();
const portNumber = protocol === "http:" ? ":3002" : "";
return `${protocol}//${useSubdomain ? "api." : ""}${hostname.split(".")[1]}${protocol === "http:" ? "" : ".com"}${portNumber}`;
}

/**
 * Validates that a subdomain exists in the current hostname.
 * If missing, navigates to the 404 page.
 */
export const validateSubdomain = (navigate: NavigateFunction): string => {
  const parts: string[] = window.location.hostname.split('.');

  // handle cases like demo-hotel.wiventory.com or demo-hotel.localhost
  const subdomain: string = parts[0];

  if (!subdomain) {
    navigate("/404");
    return "";
  }
  return subdomain;
};


export const roundTo = (value: number, decimals = 6) =>
  Math.round(value * 10 ** decimals) / 10 ** decimals;

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};
